<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.civCode, 'CIV Code')"
      v-model="civCode"
      name="civ_code"
      :rules="civCodeValidationRules"
      @input="onInput"
      variant="outlined"
      bg-color="surface"
      :tile="true"
      counter="7"
  >
    <template v-slot:append-inner>
      <v-tooltip location="top" open-delay="500" open-on-click open-on-hover>
        <template v-slot:activator="{ props }">
           <v-icon v-bind="props" class="cursor-pointer" aria-label="info">mdi-information</v-icon>
        </template>
        <span>
          <NuxtImg
              src="/images/vehicle/registration_template/template_x.png"
              class="h-100"
              loading="lazy"
              alt="Registration template"
          />
        </span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const civCode = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      civCode.value = newValue;
    });

    watch(civCode, (newValue) => {
      const valueToValidate = newValue || '';
      const isValid = validateCivCode(valueToValidate);
      emit('update:modelValue', valueToValidate);
      emit('validation-vehicle-status', { field: 'civ_code', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const civCodeValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[a-zA-Z]{1}[0-9]{6}$/i.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateCivCode(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = civCodeValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return civCodeValidationRules.every(rule => rule(value) === true);
    }

    const onInput = function (event: Event) {
      const input = event.target as HTMLInputElement;
      civCode.value = input.value.toUpperCase();
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'civ_code') {
          error.value = [];
          const isValid = validateCivCode(civCode.value, true);
          emit('validation-vehicle-status', { field: 'civ_code', isValid });
        }
      });
    });

    return {
      civCode,
      civCodeValidationRules,
      translationList,
      translation,
      onInput,
      error,
    };
  },
});
</script>

<style scoped>
</style>